// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__sc3pf","thankyou1":"Thankyou_thankyou1__D6R6V","thankyou123":"Thankyou_thankyou123__rTgIk"};